// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"c8f8920f","418":"2d9d2116","661":"702348ab"}[chunkId] + ".js";
};